module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero-about"
  }, [_c('div', {
    staticClass: "hero-about__left"
  }), _c('div', {
    staticClass: "hero-about__right",
    style: ({
      backgroundImage: 'url(' + _vm.content.hero.image + ')'
    })
  }), _c('HeroAccordion', {
    attrs: {
      "content": _vm.content
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-470bc0c3"}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/hero/about/hero-about.pug
// module id = 515
// module chunks = 1